// Dashboard.jsx
import React from "react";
import { TabProvider } from "./components/dashboardv2/context/context";
import App from "./components/dashboardv2/App";

// 1) Define and export the component
export default function Dashboard({ provID, userRole, provRole }) {
  return (
    <TabProvider provID={provID} userRole={userRole} provRole={provRole}>
      <App />
    </TabProvider>
  );
}
